import React from 'react';
import { HashRouter as Router, Routes, Route, Navigate, Link, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import Callback from './pages/Callback';
import MapPage from './pages/MapPage';
import HotelPage from './pages/HotelPage';
import Login from './pages/Login';
import OrganizationRoleSelect from './pages/OrganizationRoleSelect';
import ProfilePage from './pages/ProfilePage';
import ManualPage from './pages/ManualPage';

function TopLeftHomeLogo() {
  return (
    <Link to="/" className="global-home-logo" aria-label="Go to home">
      <img src={`${process.env.PUBLIC_URL}/logo.png`} alt="Holding the Drones" className="global-home-logo-image" />
    </Link>
  );
}

function RequireAuth({ children }) {
  const location = useLocation();
  const isAuthenticated = localStorage.getItem('authSession') === 'true';

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
}

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <TopLeftHomeLogo />
      <Routes>
        <Route path="/" element={<MapPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/callback" element={<Callback />} />
        <Route path="/org-role-select" element={<OrganizationRoleSelect />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/manual" element={<ManualPage />} />
        <Route path="/map" element={<MapPage />} />
        <Route
          path="/hotel/:id"
          element={(
            <RequireAuth>
              <HotelPage />
            </RequireAuth>
          )}
        />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
